import Awaitable from 'spiceutils/dist/Awaitable'

export default {
  setUser(state, user) {
    state.user = user
  },
  setInitialisationPromise(state, promise) {
    state.initialisationPromise = promise
  },
  setAuthenticated(state, authenticated) {
    state.isAuthenticated = authenticated
  },
  setLoading(state, loading) {
    if (loading) {
      const awaitable = new Awaitable()
      if (state.loading) {
        state.loading.resolve(awaitable)
      }

      state.loading = new Awaitable()
    } else {
      state.loading.resolve(true)
      state.loading = false
    }
  },
  setError(state, error) {
    state.error = error
  },
}
